import { Box } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import { TextRegular } from 'UiKit/typography';
import useGetRulesetDetail from 'Domain/schedule-generate/useGetRulesetDetail';

import { hours } from 'View/schedule-generate/const';
import CalendarHour from 'View/schedule-generate/component/calendar-hour';
import { useScheduleGenerateState } from 'View/schedule-generate/state';

import styles from './styles.module.css';
import getLiveHourInfo from 'View/schedule-generate/helper/getLiveHourInfo';

const CalendarContent = ({ showWeek, lastDate }) => {
  const { accounts, selectedTab, formData, generateResultData } = useScheduleGenerateState();
  const currentAccount = accounts.find((account) => account.type === selectedTab);
  const { datas } = currentAccount;
  const { metadata } = generateResultData;
  const { agency } = metadata;

  const { data: rulesetDetail } = useGetRulesetDetail({ rulesetId: formData?.rulesetId });

  const hoursInfo = getLiveHourInfo(rulesetDetail, agency);

  return (
    <Box className={styles['calendar__section--body']}>
      <Iteration
        items={hours}
        render={(hour) => {
          return (
            <Box className={styles['calendar-content__row']}>
              <Box className={styles['calendar-content__column--hour-body']}>
                <TextRegular className={styles['calendar-content__text-hour']}>{hour.dateString}</TextRegular>
              </Box>

              <CalendarHour
                showWeek={showWeek}
                lastDate={lastDate}
                hour={hour}
                datas={datas}
                accounts={accounts}
                hoursInfo={hoursInfo}
                metadata={metadata}
              />
            </Box>
          );
        }}
      />
    </Box>
  );
};

export default CalendarContent;
